
        <div class="wo-dialog-confirm__body">
            {{message}}
        </div>
        <div class="wo-dialog-confirm__buttons">
            <a class="btn btn-default" href="javascript:void(0);" (click)="close(false)">Cancel</a>
            <a class="btn btn-primary" href="javascript:void(0);" (click)="close(true)">OK</a>
        </div>
    